import { LoadingIndicator, PageContainer } from '@cointracker/styleguide';

export const PageLoading = () => {
  return (
    <PageContainer className="flex items-center justify-center p-12">
      <LoadingIndicator size={32} />
    </PageContainer>
  );
};
